<template>
    <div>
        <PageHeader :page="page" :template="'2'" @action="createNew" />
        <div class="content">
            <DataTable :tableData="tableData" @tasks="showTask" @edit="openProject" @info="showHistory" 
              @calendar_view="calendarView"/>
        </div>
    </div>

    <ModalView
        :isVisible="state.CreateModal"
        :fixclose="true"
        @close="state.CreateModal = false">
        
        <DynamicForm ref="createForm" :columns="2"
        :fields="newFields" @submit="createProject"
        :submitting="state.submitting" :errors="state.errors"
        :success="state.success" />
    </ModalView> 

    <ModalView
        :isVisible="state.editModal"
        :fixclose="true"
        @close="state.editModal = false">
        
        <DynamicForm ref="editForm" :columns="2"
        :fields="editFields" @submit="editProject"
        :submitting="state.submitting" :errors="state.errors"
        :success="state.success" />
    </ModalView> 

    <ModalView
        :isVisible="state.historyModal"
        :fixclose="true"
        @close="state.historyModal = false">
        <div v-if="!state.historyLoading">
          <HistoryItem v-for="(item, i) in history" :key="i" :hitem="item"/>
        </div>
        <div v-else style="text-align: center;">
          <img src="@/assets/img/ajldr.gif" style="width:100px"/>
        </div>
        
    </ModalView> 

  

</template>
<script>
import icons from '@/assets/js/icons.js';
import { defineComponent, reactive, ref, onMounted} from 'vue';
import PageHeader from '@/components/PageHeader.vue';
import DataTable from '@/components/DataTable.vue';
import DynamicForm from '@/components/DynamicForm.vue';
import ModalView from '@/components/ModalView.vue';
import HistoryItem from '@/components/HistoryItem.vue';
import call from "../composables/call.js";
import { urls } from "../assets/js/urls";
import { useRouter } from 'vue-router';
import { usePermissions } from '@/composables/usePermissions';

export default defineComponent({
  name: 'DepartmentsView',
  components:{PageHeader, DataTable,DynamicForm,ModalView,HistoryItem},
  setup(){
    const { hasPermission } = usePermissions();
    const createForm=ref(null);
    const editForm=ref(null);
    const router = useRouter();
    const state=reactive({CreateModal:false, submitting:false,error:[],success:false,
      editModal:false,historyModal:false, historyLoading:true});
    const svgIcons = ref(icons);
    const depts=ref([])
    const history=ref([])
    const page=reactive({title:"Projects", btn:"Create Project",
    desc:"All your project task you're involved in"})
    if(!hasPermission('Project', 'create')){
      page.btn="";
    }
    var aLabel=[icons.skills, icons.row_info],
    aAction=['tasks',"info"]

    if(hasPermission('Project', 'edit')){
      aAction.push("edit");
      aLabel.push(icons.edit)
    }

    if(hasPermission('Project', 'delete')){
      // aAction.push("delete");
      // aLabel.push(icons.trash)
    }
    const tableData = ref({
      rows: [],
      loading: true,
      columns: [
        { label: "Project name" },
        { label: "Privacy" },
        { label: "Due date" }
      ],
      options:{
        label:"Actions",
        action_label:aLabel,
        action:aAction
      },
      total:0
    });

    if(hasPermission('Schedule', 'view')){
      tableData.value.options.action.push("calendar_view");
      tableData.value.options.action_label.push(icons.schedule);
    }

    const newFields=ref([
      { name: "Create Project", number: "1",data: 
        [{ type: 'text', name: 'name', label: 'Project Name',
          value: ""  },
          { type: 'date', name: 'deadline', label: 'Deadline',
          value: ""  },
          { type: 'selectGroup', name: 'privacy', label: 'Privacy',
            value: "",
            options:[
                {label:"Generic",options:[
                    {label:"Company wide", value:"1"}, 
                    {label:"Members only", value:"2"},
                    {label:"Private to me", value:"3"},
                ]},
                {label:"Departments",options:depts},
            ]
          }
        ]
      }
    ])

    const editFields=ref([]);
    function createNew(){
      state.success=false;
      state.error=[]
      state.CreateModal=true;
    }

    function setTable(msg){
      var data={}
      tableData.value.loading = false;
      tableData.value.rows.length=0
      Object.keys(msg).forEach(set => {
        data={id:msg[set].id};
        var v=[];
        Object.keys(msg[set].val).forEach(row => {
          v.push(msg[set].val[row])
        });
        data.val=v;
        tableData.value.rows.push(data)
      });
      tableData.value.total=tableData.value.rows.length
    }

    onMounted(() => {
      call({
        url:urls.task,
        data:{startProject:""},
        success:(res)=>{
          state.loaded=true
          if(res.status){
            var d=res.msg;
            depts.value=[];
            Object.keys(d.dept).forEach(k => {
              depts.value.push(d.dept[k])
            })
            setTable(d.projects);
          }else{
            alert(res.msg);
          }
        }
      })
    });

    function createProject(data){
        state.submitting=true;
        state.errors=[];
        data.createProject="";
        call({
            url:urls.task,
            data:data,
            success:(res)=>{
                state.submitting=false;
                if(res.status){
                state.success=true;
                setTable(res.msg);
                }else{
                setErrors(res)
                }
            }
        })
    }

    function setErrors(res){
        var errors=[];
        Object.keys(res.msg).forEach(key => {
        var e=res.msg[key],er="";
        Object.keys(e).forEach(k => {
            er+=er=="" ? e[k] : ", "+e[k]
        })
        errors.push(er);
        });
        state.errors=errors;
    }

    function showTask(i){
        var data=tableData.value.rows[i];
        router.push({ name: 'tasksview', params: { project: data.id } });
    }

    function getPvalue(n){
      if(n=="Company wide"){return "1"}
      if(n=="Members only"){return "2"}
      if(n=="Private to me"){return "3"}
      var p=n.replace(/Department only/, '').trim(),
      s="";
      Object.keys(depts.value).forEach(d => {
        if(depts.value[d].label.trim()==p.trim()){
          s=depts.value[d].value;
        }
      })
      return s;
    }

    function openProject(i){
      state.success=false;
      state.error=[]
      var data=tableData.value.rows[i]
      editFields.value.length=0;
      editFields.value.push(
        { name: "Edit Project", number: "1",data: 
        [{ type: 'text', name: 'name', label: 'Project Name',
          value: data.val[0]  },
          { type: 'date', name: 'deadline', label: 'Deadline',
          value: ""  },
          { type: 'selectGroup', name: 'privacy', label: 'Privacy',
            value: getPvalue(data.val[1]),
            options:[
                {label:"Generic",options:[
                    {label:"Company wide", value:"1"}, 
                    {label:"Members only", value:"2"},
                    {label:"Private to me", value:"3"},
                ]},
                {label:"Departments",options:depts},
            ]
          },
          { type: 'hidden', name: 'id', value: data.id }
        ]
      })
      state.editModal=true;
    }

    function editProject(data){
      state.submitting=true;
      state.errors=[];
      data.editProject="";
      call({
        url:urls.task,
        data:data,
        success:(res)=>{
          state.submitting=false;
          if(res.status){
            state.success=true;
            setTable(res.msg);
          }else{
            setErrors(res)
          }
        }
      })
    }

    function showHistory(i){
      state.historyModal=true;
      state.historyLoading=true;
      var data={getProjectHistory: tableData.value.rows[i].id};
      call({
        url:urls.task,
        data:data,
        success:(res)=>{
          state.historyLoading=false;
          if(res.status){
            history.value=res.msg;
          }else{
            alert(res)
          }
        }
      });
    }

    function calendarView(i){
      var id=tableData.value.rows[i].id
      router.push({ name: 'calendar', params: { id: id, type:"project" } });
    }


    return{page,icons: svgIcons.value,tableData,state,createForm,editFields,showHistory,history,
        newFields,createNew,createProject,showTask,editForm,editProject,openProject,calendarView
    }
  }
})

</script>   

<style scoped>
p{color:#737373 !important; font-family: Inter, Helvetica, Arial, sans-serif;}
.box > *{padding: 0 calc(1.5rem * 0.5);}
.box .card{background:var(--white-color); border-radius: 0.5rem}
.card-header:first-child {border-radius: 0.5rem 0.5rem 0 0;padding: 0.5rem !important;
    padding-left: 1rem !important;background-color: var(--white-color);
    border-bottom: 0 solid #e5e5e5;}
.iconwrap{border-radius: 0.5rem; width: 48px;height: 48px; background-position: center;
    background-image: linear-gradient(195deg, #42424a 0%, #191919 100%);
    box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.14), 0 7px 10px -5px rgba(64, 64, 64, 0.4) !important;
    text-align: center !important; display: flex; align-items: center; justify-content: center;}
.iconwrap .ic{width:18px; height:18px; fill:var(--white-color);line-height: 0em;}
.text-sm {font-size: 0.875rem !important; line-height: 1.5;}
.text-capitalize {text-transform: capitalize !important;}
h4{font-size: 1.5rem; line-height: 1.375; font-weight: 600;}
hr.horizontal.dark {background-image: linear-gradient(90deg, transparent, rgba(0, 0, 0, 0.4), transparent);}
.my-0 {margin-top: 0 !important; margin-bottom: 0 !important;}
hr.horizontal {background-color: transparent;}
hr {border-top: none; height: 1px;}
hr {color: inherit; border: 0; opacity: 0.25;}
.ps-3 {padding-left: 1rem !important;}
.p-2 {padding: 0.5rem !important;}
</style>
<style>
.iclst .trash_ic {stroke: var(--red); fill:none}
</style>